export default __webpack_public_path__ + "static/media/club5.f5bb6564.webp";